export const difficulties = [
  'mythic',
  'heroic',
  'normal',
  'raid_finder',
] as const

export const difficultiesLabels = {
  mythic: 'Mythic',
  heroic: 'Heroic',
  normal: 'Normal',
  raid_finder: 'LFR',
} as const

export const difficultiesILVLDeficit = {
  Mythic: 0,
  Heroic: -13,
  Normal: -26,
  LFR: -39,
}

type Difficulty = typeof difficulties[number]
export default Difficulty
